import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import GroupsContainer from '../../containers/my-groups/groups.container';
import TopNavBar from '../../containers/top-nav-bar.container';
import Footer from '../../containers/footer.container';

class MyGroups extends Component {
  render() {
    return (
      <div>
        <TopNavBar />
        <div className="container px-0">
          <h1 className="my-5">
            <FormattedMessage
              id="myGroups.pageTitle"
              defaultMessage="My Groups"
            />
          </h1>
          <GroupsContainer />
        </div>
        <Footer />
      </div>
    );
  }
}

export default MyGroups;



// WEBPACK FOOTER //
// ./src/desktop/components/my-groups/index.js